import React, { Suspense } from 'react';
import {
  FormContainer,
  MappedResults,
} from '../../CreateRoutes/CreateForm.styles';
import { useParams } from 'react-router-dom';
import { AuthCheckAdmin } from '../../../Utils/AuthCheck/AdminCheck.auth';
const CreateManager = React.lazy(() => import('./CreateManager.component'));
const MappedUsersOrEmployee = React.lazy(
  () => import('./MappedManagersUsers.component')
);
const BreadCrumbs = React.lazy(
  () => import('../../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);
const HelmetHelper = React.lazy(
  () => import('../../../Components/PageHelmet/HelmetHelper.component')
);
import ManagersDataProvider from '../../../Utils/Companies/Managers-Employees/ManagersDataProvider';
import EmployeesDataProvider from '../../../Utils/Companies/Managers-Employees/EmployeesDataProvider';

// This is the outer component
const EditManagersAndUsers = () => {
  const { id } = useParams();

  return (
    <AuthCheckAdmin>
      <Suspense fallback={<p>Loading page metadata...</p>}>
        <HelmetHelper
          title="Edit Managers and Users"
          description="Form to edit managers and user"
        />
      </Suspense>
      <FormContainer>
        <Suspense fallback={<p>Loading breadcrumbs...</p>}>
          <BreadCrumbs
            one="Company Info (Admin)"
            oneLink={`/admin/company-home/${id}`}
            two="Edit Managers & Employees"
          />
        </Suspense>
        <h2>Managers and Employees</h2>
        <Suspense fallback={<p>Loading create manager form...</p>}>
          <CreateManager />
        </Suspense>
        <ManagersDataProvider companyId={id}>
          {(managers) => (
            <MappedResults>
              <Suspense fallback={<p>Loading managers...</p>}>
                <MappedUsersOrEmployee
                  users={managers}
                  title="Company Managers"
                />
              </Suspense>
            </MappedResults>
          )}
        </ManagersDataProvider>
        <EmployeesDataProvider companyId={id}>
          {(employees) => (
            <MappedResults>
              <Suspense fallback={<p>Loading employees...</p>}>
                <MappedUsersOrEmployee
                  users={employees}
                  title="Company Employees"
                />
              </Suspense>
            </MappedResults>
          )}
        </EmployeesDataProvider>
      </FormContainer>
    </AuthCheckAdmin>
  );
};

export default EditManagersAndUsers;
